import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { EConfigActions, GetConfig, GetConfigSuccess } from '../actions/config.actions';
import { ConfigHelpers } from '@eview/core/config/config.helpers';
import { MapConfigItem } from '@eview/core/models/config';
import { Position } from '@eview/core/models/map';
import { SetMapDefaults } from '../actions/map.actions';
import { ETenantActions, GetTenantSuccess } from '../actions/tenant.actions';
@Injectable()
export class MapEffects {
  private readonly actions$ = inject(Actions);

  onGetConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetTenantSuccess>(ETenantActions.GetTenantSuccess),
      switchMap(action => {
        const mapConfig = action.payload;
        return of(
          new GetConfig(),
          new SetMapDefaults({
            defaults: {
              lat: mapConfig.map.lat || 0,
              lon: mapConfig.map.lon || 0,
              zoom: mapConfig.map.zoom || 0
            }
          })
        );
      }),
      catchError(() => of(new SetMapDefaults({ defaults: { lat: 0, lon: 0, zoom: 0 } })))
    )
  );

  // Ejemplo comentado actualizado
  // onGetConfig$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType<GetConfigSuccess>(EConfigActions.GetConfigSuccess),
  //     switchMap(action => {
  //       const mapConfig = ConfigHelpers.GetConfigItem<MapConfigItem>(
  //         MapConfigItem,
  //         action.payload
  //       );
  //       return of(
  //         new SetMapDefaults({
  //           defaults: {
  //             lat: mapConfig.default_view.lat || 0,
  //             lon: mapConfig.default_view.lon || 0,
  //             zoom: mapConfig.default_view.zoom || 0
  //           }
  //         })
  //       );
  //     }),
  //     catchError(() => of(new SetMapDefaults({ defaults: { lat: 0, lon: 0, zoom: 0 } })))
  //   )
  // );
}
